module.exports = __webpack_public_path__ + "img/desktop-for-business.b3e2f405.png";